import { Routes, Route } from 'react-router-dom';

import RequiresAuth from '../Participant/Auth/RequiresAuth';
import AdminMenu from './AdminMenu';
import Funds from './Funds';
import AddEmails from './AddEmails';
import CheckEmail from './CheckEmail';

function Participant () 
{
    return  <RequiresAuth>
                <Routes>
                    <Route path="/funds" element={ <Funds /> } />
                    <Route path="/emails/add" element={ <AddEmails /> } />
                    <Route path="/emails/check" element={ <CheckEmail /> } />
                    <Route path="/" element={ <AdminMenu/> } />
                </Routes>
            </RequiresAuth>
}

export default Participant;